import { render, staticRenderFns } from "./detail-ball.vue?vue&type=template&id=ddc242ec&scoped=true&"
import script from "./detail-ball.vue?vue&type=script&lang=js&"
export * from "./detail-ball.vue?vue&type=script&lang=js&"
import style0 from "./detail-ball.vue?vue&type=style&index=0&id=ddc242ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc242ec",
  null
  
)

export default component.exports